var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M19.8555 3H5.85547C4.75547 3 3.85547 3.9 3.85547 5V19C3.85547 20.1 4.75547 21 5.85547 21H19.8555C20.9555 21 21.8555 20.1 21.8555 19V5C21.8555 3.9 20.9555 3 19.8555 3ZM9.85547 17H7.85547V10H9.85547V17ZM13.8555 17H11.8555V7H13.8555V17ZM17.8555 17H15.8555V13H17.8555V17Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
